letterAdjust.scale = 0.8;
var font = {
  ".": "M0,0h157v157H0V0z",
  "0": "M0 93l98 -93h348l100 93v877l-100 95h-348l-98 -95v-877zM149 144v777h245v-777h-245z",
  "1": "M0 0h357v144h-104v921h-149l-104 -164v-45h104v-712h-104v-144z",
  "2": "M0 0h542v144h-393v139l393 263v424l-96 95h-348l-98 -95v-114h149v65h244v-298l-393 -262v-361z",
  "3": "M0 93l96 -93h350l97 93v368l-68 71l68 72v366l-97 95h-350l-96 -95v-114h149v65h245v-317h-182v-143h182v-317h-245v65h-149v-116z",
  "4": "M0 333h389v-189h-103v-144h359v144h-105v189h105v143h-105v589h-183l-357 -518v-214zM131 476l258 377v-377h-258z",
  "5": "M0 94l98 -94h349l98 94v417l-98 93h-297v317h395v144h-545v-604h395v-317h-245v65h-150v-115z",
  "6": "M0 94l99 -94h348l99 94v417l-99 93h-297v317h245v-64h151v115l-99 93h-348l-99 -93v-878zM150 144v317h245v-317h-245z",
  "7": "M0 857h150v64h333l-390 -921h162l365 865v200h-620v-208z",
  "8": "M0 94l99 -94h348l98 94v367l-70 71l70 72v368l-98 93h-348l-99 -93v-368l71 -72l-71 -71v-367zM150 144v317h244v-317h-244zM150 604v317h244v-317h-244z",
  "9": "M0 94l98 -94h347l100 94v876l-100 95h-347l-98 -95v-415l98 -94h296v-316h-246v64h-148v-115zM148 606v314h246v-314h-246z",
  "A": "M0 0h161l28 157h152l28 -157h161l-187 1065h-156zM214 313l51 284l50 -284h-101z",
  "B": "M0 0h404l132 132v329l-80 81l80 81v310l-132 132h-404v-1065zM157 157v306h219v-306h-219zM157 623v285h219v-285h-219z",
  "C": "M0 132l133 -132h271l132 132v179h-158v-154h-221v751h221v-155h158v180l-132 132h-271l-133 -132v-801z",
  "D": "M0 0h404l132 132v801l-132 132h-404v-1065zM160 157v751h218v-751h-218z",
  "E": "M0 0h530v157h-373v306h191v160h-191v285h373v157h-530v-1065z",
  "F": "M0 0h157v463h191v160h-191v285h373v157h-530v-1065z",
  "G": "M0 132l132 -132h268l135 132v357h-270v-157h113v-175h-219v751h219v-155h157v180l-135 132h-268l-132 -132v-801z",
  "H": "M0 0h155v463h221v-463h156v1065h-156v-442h-221v442h-155v-1065z",
  "I": "M0 0h157v1065h-157v-1065z",
  "J": "M0 132l133 -132h271l132 132v933h-158v-908h-219v154h-159v-179z",
  "K": "M0 0h157v415l30 48l175 -463h168l-243 643l243 422h-182l-191 -332v332h-157v-1065z",
  "L": "M0 0h422v157h-265v908h-157v-1065z",
  "M": "M0 0h159v615l109 -293l110 293v-615h158v1065h-158l-110 -293l-109 293h-159v-1065z",
  "N": "M0 0h157v604l219 -604h160v1065h-160v-604l-219 604h-157v-1065z",
  "O": "M0 132l133 -132h271l132 132v801l-132 132h-271l-133 -132v-801zM157 157v751h221v-751h-221z",
  "P": "M0 0h157v463h247l132 134v336l-132 132h-404v-1065zM157 623v285h221v-285h-221z",
  "Q": "M0 132l132 -131h209l53 -100h101l-67 123l108 108v803l-130 130h-274l-132 -130v-803zM159 157v752h222v-752h-222z",
  "R": "M0 0h159v463h137l80 -463h160l-91 510l90 87v336l-131 132h-404v-1065zM159 623v285h217v-285h-217z",
  "S": "M0 132l133 -132h271l132 132v357l-132 134h-245v285h219v-155h158v180l-132 132h-271l-133 -132v-336l133 -134h245v-306h-219v154h-159v-179z",
  "T": "M0 908h189v-908h159v908h188v157h-536v-157z",
  "U": "M0 132l133 -132h271l132 132v933h-158v-908h-219v908h-159v-933z",
  "V": "M0 1065l212 -1065h129l213 1065h-160l-117 -583l-116 583h-161z",
  "W": "M0 1065l99 -1065h154l62 343l63 -343h157l99 1065h-161l-41 -468l-86 468h-60l-85 -468l-42 468h-159z",
  "X": "M0 0h166l102 290l98 -290h169l-185 532l185 533h-169l-98 -290l-102 290h-166l185 -533z",
  "Y": "M0 1065l187 -542v-523h156v523l189 542h-167l-100 -288l-101 288h-164z",
  "Z": "M0 176l60 -176h435l37 157h-366l366 731l-57 177h-438l-37 -157h366z"
};
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font_size = 24,
  edmonton = true,
  panel_Hor_Adjustment = 2,
  font_Top_Adjustment = -21,
  tracking = 2,
  small_Caps_Adjustment = {
    vertical: -250,
    horizontal: 0,
    scale_width: 0, // this effects with the numbers
    scale_height: 0, // this effects with the numbers
  },
  colors = {
    characters: {
      home: [
        "#FFFFFF", // white
        "#003e7e", //blue011e41
      ],
      away: [
        "#003e7e", // blue011e41
      ],
      third: [
        "#F05123", // orange
      ]
    },
    numbers: {
      home: [
        "#e86d1f", // blue011e41
        "#003e7e", // white
        "#ffffff",
      ],
      away: [
        "#003e7e", // blue011e41
        "#ffffff", // orangeFF4d00
        "#e86d1f",
      ],
      third: [
        "#F05123", // orange
      ]
    }
  },
  outlines = {
    characters: {
      width: 2.5
    },
    numbers: {
      width: 2.5
    }
  },
  special_Character_Adjustments = {
    period: {
      vertical: 6, // this moves it up from the bottom
      horizontal: -1,
      scale_width: 35.5,
      scale_height: 35.5,
    },
    hyphen: {
      vertical: -8,
      horizontal: -5.5,
      scale_width: 0,
      scale_height: -3,
    },
    apostrophe: {
      vertical: -0.75, // this is backwards
      horizontal: -1,
      scale_width: 0,
      scale_height: 0,
    }
  },
  number_Adjustments = {
    top: 12,
    left: -5,
    width: 130,
    height: 95,
    middle_Space: 5,
  };